export function win({
                        isLine,
                        selectedTeam,
                        favoredName,
                        perCoin,
                        riskCoins,
                        instaplay,
                        isSimple,
                        isPool,
                        isBracket,
                        active,
                        completed,
                        selection,
                        risk,
                        preview
                    }) {
    if (isLine)
        return !selectedTeam ? '?' :
            selectedTeam === favoredName ?
                (perCoin + 10) * riskCoins :
                (perCoin + instaplay.line.SCoinUnderdog) * riskCoins
    else if (isSimple)
        return instaplay.simple.winSCoins
    else if (isPool)
        return active || completed
            ? instaplay.pool.winSCoins - selection.risked + risk
            : preview ? instaplay.pool.SCoinGM + risk
                : instaplay.pool.winSCoins + risk
    else if (isBracket)
        return active || completed
            ? instaplay.bracket.winSCoins - selection.risked + risk
            : preview ? instaplay.bracket.SCoinGM + risk
                : instaplay.bracket.winSCoins + risk
    return !selectedTeam ? '?' : (perCoin + 10) * riskCoins
}
